// extracted by mini-css-extract-plugin
export default {"userGroupsTabContainer":"UserGroupsTab_userGroupsTabContainer__RTYhO","addCheckBox":"UserGroupsTab_addCheckBox__cD2J6","removeCheckBox":"UserGroupsTab_removeCheckBox__zxyDY"};